<dx-data-grid #grid [dataSource]="costs" [showColumnLines]="false" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true" [columnAutoWidth]="true"
    (onToolbarPreparing)="onToolbarPreparingCosts($event)"
    (onEditorPreparing)="onEditorPreparingCosts($event)">
    <dxo-editing mode="batch" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="false"></dxo-editing>
    <dxi-column cellTemplate="valueFromToTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false" [caption]="'CUSTOMER_ORDERS.FOR_ORDERS' | translate"></dxi-column>
    <dxi-column cellTemplate="descriptionTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false" [caption]="'SHARED.DESCRIPTION' | translate"></dxi-column>
    <dxi-column dataField="value" dataType="string" [allowFiltering]="false" [allowSorting]="false" [caption]="'SHARED.VALUE' | translate"></dxi-column>

    <div *dxTemplate="let template of 'valueFromToTemplate'">
        <span>{{ template.data.costPolicy.orderValueFrom }} - {{ template.data.costPolicy.orderValueTo }}</span>
    </div>
    <div *dxTemplate="let template of 'descriptionTemplate'">
        <span>{{ template.data.costPolicy.description }}</span>
    </div>
</dx-data-grid>

<dx-popup width="600px" maxWidth="80%" height="220px" maxHeight="80%" [(visible)]="isCostsFormVisible" [title]="'SHARED.ADD_ITEM' | translate" (onHiding)="closeCostsForm()">
    <div class="dx-fieldset" *ngIf="isCostsFormVisible">
        <div class="dx-field">
            <div class="dx-field-label">{{ 'CUSTOMER_ORDERS.COSTS' | translate}}</div>
            <div class="dx-field-value">
                <dx-select-box [dataSource]="costPolicies" displayExpr="description" [searchEnabled]="true" [(value)]="selectedCost"></dx-select-box>
            </div>
        </div>
    </div>
    <hr>
    <div class="dx-popup-footer">
        <div class="row col-sm-8 offset-sm-2">
            <div class="col-sm">
                <dx-button class="navbar-button btn-block" [height]="32" stylingMode="contained" icon="{{costsFormSubmitIcon}}" [text]="costsFormSubmitCaption | translate" type="success" [disabled]="loadingService.unfinishedRequests" (onClick)="saveCost()"></dx-button>
            </div>
            <div class="col-sm">
                <dx-button class="navbar-button btn-block" [height]="32" stylingMode="outlined" icon="close" [text]="'SHARED.CLOSE' | translate" type="normal" [disabled]="loadingService.unfinishedRequests" (onClick)="closeCostsForm()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>